// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.mjs";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.mjs";
import * as FormTextInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.mjs";
import * as FormSelectInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.mjs";
import * as SelectComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as PartnerStore$PorterinFeature from "../../domain/repo/store/PartnerStore.mjs";
import * as PartnersHelper$PorterinFeature from "../helpers/PartnersHelper.mjs";
import * as PartnersFormModuleScss from "../styles/PartnersForm.module.scss";
import * as PartnerFormInterface$PorterinFeature from "../../domain/repo/types/PartnerFormInterface.mjs";

var styles = PartnersFormModuleScss;

function PartnersFormCmp(Props) {
  var initialCity = Props.initialCity;
  var submitPartnerDetailsInfo = Props.submitPartnerDetailsInfo;
  var setCity = Props.setCity;
  var cities = Props.cities;
  var vehicles = Props.vehicles;
  var infoSourceList = Props.infoSourceList;
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var match = React.useState(function () {
        return false;
      });
  var setVehiclesError = match[1];
  var vehiclesError = match[0];
  var citiesSelectComponentList = PartnersHelper$PorterinFeature.getSelectComponentItems(cities, PartnersHelper$PorterinFeature.partnerCityToSelectConv);
  var infoSelectComponentList = PartnersHelper$PorterinFeature.getSelectComponentItems(infoSourceList, PartnersHelper$PorterinFeature.infoSourceToSelectConv);
  var getVehiclePlaceholderInput = function (msg) {
    return React.createElement("div", {
                className: styles["click-handler"],
                onClick: (function (param) {
                    Curry._1(setVehiclesError, (function (param) {
                            return true;
                          }));
                  })
              }, React.createElement(FormTextInput$Catalyst.make, {
                    input_props: FormInput$Catalyst.make_props("Vehicles", (function (param) {
                            
                          }), true, undefined, msg, undefined, undefined, undefined, undefined, undefined, styles["modal-form-input"] + " " + styles.vehicle, undefined, undefined, {
                          className: "form-input-text",
                          startAdornment: React.createElement("div", undefined),
                          accept: undefined
                        }, undefined, undefined, undefined, undefined),
                    textinput_props: {
                      value: ""
                    }
                  }));
  };
  var form = PartnerFormInterface$PorterinFeature.Form.useForm({
        name: "",
        mobile: "",
        city: List.find_opt((function (selectOpt) {
                return selectOpt.key === String(initialCity.id);
              }), citiesSelectComponentList),
        vehicle: undefined,
        infoSource: undefined
      }, (function (output, submissionCbs) {
          var formData_name = output.name;
          var formData_mobile = output.mobile;
          var formData_city = output.city;
          var formData_vehicleType = output.vehicle;
          var formData_infoSource = output.infoSource;
          var formData = {
            name: formData_name,
            mobile: formData_mobile,
            city: formData_city,
            vehicleType: formData_vehicleType,
            infoSource: formData_infoSource
          };
          PartnersHelper$PorterinFeature.formEventHandler(citySelectedContext.category, "Register Successful", output.name, output.mobile, String(output.vehicle.id), String(output.city.id));
          Curry._1(submitPartnerDetailsInfo, formData);
          Curry._1(submissionCbs.notifyOnSuccess, undefined);
        }));
  var tmp;
  if (typeof vehicles === "number") {
    tmp = getVehiclePlaceholderInput("Select Vehicle");
  } else {
    switch (vehicles.TAG | 0) {
      case /* Loading */0 :
          tmp = getVehiclePlaceholderInput(PartnerStore$PorterinFeature.loading_vehicles);
          break;
      case /* Live */1 :
          var vehs = vehicles._0;
          tmp = React.createElement(FormSelectInput$Catalyst.make, {
                input_props: FormInput$Catalyst.make_props("Vehicle", (function ($$event) {
                        Curry._2(form.updateVehicle, (function (input, value) {
                                return {
                                        name: input.name,
                                        mobile: input.mobile,
                                        city: input.city,
                                        vehicle: value,
                                        infoSource: input.infoSource
                                      };
                              }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), PartnersHelper$PorterinFeature.getSelectComponentItems(vehs, PartnersHelper$PorterinFeature.partnerVehicleToSelectConv)));
                      }), undefined, undefined, "SELECT VEHICLE", undefined, undefined, undefined, form.vehicleResult, undefined, PartnersHelper$PorterinFeature.getInputClass("modal-form-input vehicle", form.vehicleResult), undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                select_props: {
                  value: form.input.vehicle,
                  items: PartnersHelper$PorterinFeature.getSelectComponentItems(vehs, PartnersHelper$PorterinFeature.partnerVehicleToSelectConv),
                  isNoneRequired: false
                }
              });
          break;
      case /* Error */2 :
          tmp = getVehiclePlaceholderInput(PartnerStore$PorterinFeature.try_again);
          break;
      
    }
  }
  return React.createElement("form", {
              className: styles["attach-vehicle-form"],
              id: "partner-form",
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                })
            }, React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Name", (function ($$event) {
                          Curry._2(form.updateName, (function (input, value) {
                                  return {
                                          name: value,
                                          mobile: input.mobile,
                                          city: input.city,
                                          vehicle: input.vehicle,
                                          infoSource: input.infoSource
                                        };
                                }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.nameResult, undefined, PartnersHelper$PorterinFeature.getInputClass("modal-form-input name", form.nameResult), undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.name
                  }
                }), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Mobile Number", (function ($$event) {
                          Curry._2(form.updateMobile, (function (input, value) {
                                  return {
                                          name: input.name,
                                          mobile: value,
                                          city: input.city,
                                          vehicle: input.vehicle,
                                          infoSource: input.infoSource
                                        };
                                }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.mobileResult, undefined, PartnersHelper$PorterinFeature.getInputClass("modal-form-input mobile", form.mobileResult), undefined, undefined, {
                        className: styles["form-input-text"],
                        startAdornment: React.createElement("div", {
                              className: "text-input-adornment"
                            }, PartnerStore$PorterinFeature.isd_code + " - "),
                        accept: undefined
                      }, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: form.input.mobile
                  }
                }), React.createElement("div", {
                  className: styles["same-row-fields"]
                }, React.createElement(FormSelectInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("City", (function ($$event) {
                              Curry._2(form.updateCity, (function (input, value) {
                                      return {
                                              name: input.name,
                                              mobile: input.mobile,
                                              city: value,
                                              vehicle: input.vehicle,
                                              infoSource: input.infoSource
                                            };
                                    }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), citiesSelectComponentList));
                              Curry._1(setCity, FormHelper$Catalyst.TargetEventWrapper.value($$event));
                              Curry._1(setVehiclesError, (function (param) {
                                      return false;
                                    }));
                              Curry._2(form.updateVehicle, (function (input, value) {
                                      return {
                                              name: input.name,
                                              mobile: input.mobile,
                                              city: input.city,
                                              vehicle: value,
                                              infoSource: input.infoSource
                                            };
                                    }), undefined);
                            }), undefined, undefined, undefined, undefined, undefined, undefined, vehiclesError ? ({
                                TAG: /* Error */1,
                                _0: "Please select the city"
                              }) : form.cityResult, undefined, PartnersHelper$PorterinFeature.getInputClass("modal-form-input city", vehiclesError ? ({
                                    TAG: /* Error */1,
                                    _0: "Please select the city"
                                  }) : form.cityResult), undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      select_props: {
                        value: form.input.city,
                        items: citiesSelectComponentList,
                        isNoneRequired: false
                      }
                    }), tmp), React.createElement(FormSelectInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Source", (function ($$event) {
                          Curry._2(form.updateInfoSource, (function (input, value) {
                                  return {
                                          name: input.name,
                                          mobile: input.mobile,
                                          city: input.city,
                                          vehicle: input.vehicle,
                                          infoSource: value
                                        };
                                }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), infoSelectComponentList));
                        }), undefined, undefined, "WHERE DID YOU HEAR ABOUT US?", undefined, undefined, undefined, form.infoSourceResult, undefined, PartnersHelper$PorterinFeature.getInputClass("modal-form-input info-source", form.infoSourceResult), undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  select_props: {
                    value: form.input.infoSource,
                    items: infoSelectComponentList,
                    isNoneRequired: false
                  }
                }), React.createElement("button", {
                  className: styles["modal-form-button"] + " " + styles["request-btn"],
                  onClick: (function (param) {
                      PartnersHelper$PorterinFeature.formEventHandler(citySelectedContext.category, "Register Clicked", form.input.name, form.input.mobile, PartnersHelper$PorterinFeature.getKeyFromSelectOrBlank(form.input.vehicle), PartnersHelper$PorterinFeature.getKeyFromSelectOrBlank(form.input.city));
                      Curry._1(form.submit, undefined);
                    })
                }, "REGISTER"));
}

var make = PartnersFormCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
